//src/services/homepage.api.js
import { apiRequest } from "./api";

export const getHomepageCategoryCards = () =>
  apiRequest("/homepage/category-cards");


export const getHomepageFeaturedCategories = () =>
  apiRequest("/homepage/featured-categories");

export const getHomepageCategoryCarouselSection = () =>
  apiRequest("/homepage/category-carousel-section");

export const getAboutPageSettings = () =>
  apiRequest("/homepage/about-page");

export const getTermsConditionsSettings = () =>
  apiRequest("/homepage/terms-conditions");

export const getPrivacyPolicySettings = () =>
  apiRequest("/homepage/privacy-policy-settings");

export const getPaymentDeliverySettings = () =>
  apiRequest("/homepage/payment-delivery-settings");

export const getReturnsPageSettings = () =>
  apiRequest("/homepage/returns-page-settings");

export const getHomepageSearchOverlaySettings = () =>
  apiRequest("/homepage/search-overlay");

export const getProductsPageFeaturedSection = () =>
  apiRequest("/homepage/products-page-featured");

export const getProductInstagramReelsSection = () =>
  apiRequest("/homepage/product-instagram-reels");

export const getProductLookSection = () =>
  apiRequest("/homepage/product-look-section");

export const getHeaderOverlayImages = () =>
  apiRequest("/homepage/header-overlay-images");

export const getHomepageCategoryProductRows = () =>
  apiRequest("/homepage/category-product-rows");